import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'
import type { PluginListenerHandle } from '@capacitor/core'
import { router } from '@/shared/lib/router'

/**
 * Routes Capacitor app-link / universal-link opens into the web router.
 *
 * Only same-origin app URLs on known paths are honored; anything else is
 * ignored so a crafted link cannot navigate the app to an arbitrary route.
 */
export function registerDeepLinkHandler(): Promise<PluginListenerHandle> | null {
  if (!Capacitor.isNativePlatform()) return null

  return App.addListener('appUrlOpen', ({ url }) => {
    try {
      const parsed = new URL(url)
      const path = parsed.pathname + parsed.search
      if (parsed.pathname.startsWith('/redeem')) {
        void router.navigate(path)
      }
    } catch {
      // Ignore malformed URLs.
    }
  })
}
